import { FC } from 'react';
import Page, { PageProps } from '@/components/page';
import RouterTabs from '@/components/router-tabs';
import IntForm from './int-form';
import ProfileForm from './profile-form';
import BrandingForm from './branding-form';
import CustomMessageForm from './custom-message-form';
import IdentForm from './ident-form';

const OrgSettingsPage: FC<PageProps> = () => {
  return (
    <Page title="Organization Settings">
      <RouterTabs
        panels={[
          { label: 'Profile', path: 'profile', component: <ProfileForm /> },
          { label: 'Integration', path: 'integration', component: <IntForm /> },
          { label: 'Identity', path: 'identity', component: <IdentForm /> },
          { label: 'Branding', path: 'branding', component: <BrandingForm /> },
          { label: 'Custom Messages', path: 'custom-messages', component: <CustomMessageForm /> },
        ]}
      />
    </Page>
  );
};

export default OrgSettingsPage;
